module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "latest-wrapper"
  }, [_c('h1', {
    staticClass: "main-title individual grid-container"
  }, [_vm._v("Latest")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation latest layer3"
  }), _vm._v(" "), _c('div', {
    staticClass: "social-latest grid-100 grid-parent layer2"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-100"
  }, [_c('div', {
    staticClass: "fb-box odd grid-48"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "fb-post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.fbPosts[0].message)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.fbPosts[0].date))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-box even grid-24 margin-left-2"
  }, [(_vm.twPosts[0]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[0].id_str
    }
  }, [_c('h4', [_vm._v("@Realrossnoble")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tw-post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.twPosts[0].text)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.getDateInFormatTW(_vm.twPosts[0].created_at)))]), _vm._v(" "), _c('div', {
    staticClass: "social-icon"
  }, [(_vm.twPosts[0]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[0].id_str
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/twitter.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tw-box odd grid-24 margin-left-2"
  }, [(_vm.twPosts[1]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[1].id_str
    }
  }, [_c('h4', [_vm._v("@Realrossnoble")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tw-post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.twPosts[1].text)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.getDateInFormatTW(_vm.twPosts[1].created_at)))]), _vm._v(" "), _c('div', {
    staticClass: "social-icon"
  }, [(_vm.twPosts[1]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[1].id_str
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/twitter_white.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tw-box even grid-24"
  }, [(_vm.twPosts[2]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[2].id_str
    }
  }, [_c('h4', [_vm._v("@Realrossnoble")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tw-post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.twPosts[2].text)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.getDateInFormatTW(_vm.twPosts[2].created_at)))]), _vm._v(" "), _c('div', {
    staticClass: "social-icon"
  }, [(_vm.twPosts[2]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[2].id_str
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/twitter.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "fb-box odd grid-48  margin-left-2"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "fb-post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.fbPosts[2].message)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.fbPosts[1].date))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "tw-box even grid-24 margin-left-2"
  }, [(_vm.twPosts[3]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[3].id_str
    }
  }, [_c('h4', [_vm._v("@Realrossnoble")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.twPosts[3].text)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.getDateInFormatTW(_vm.twPosts[3].created_at)))]), _vm._v(" "), _c('div', {
    staticClass: "social-icon"
  }, [(_vm.twPosts[3]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[3].id_str
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/twitter.png")
    }
  })]) : _vm._e()])])])])]), _vm._v(" "), (_vm.itemData.id) ? _c('div', {
    staticClass: "overlay-grid grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "social-latest grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-100 grid-parent archive-list"
  }, [_c('div', {
    staticClass: "grid-32 archive-item grid-parent"
  }, [_c('div', {
    staticClass: "grid-100 grid-parent archive-content"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.itemData.title.rendered)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.itemData.content.rendered)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "archive-bottom grid-100 grid-parent mobile-grid-100"
  }, [_c('span', {
    staticClass: "archive-date"
  }, [_vm._v(_vm._s(_vm.getDateInFormat(_vm.itemData.date)))])])])])])])]), _vm._v(" "), _c('a', {
    staticClass: "close-archive",
    on: {
      "click": function($event) {
        return _vm.closeOverlay()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/close.png")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "main-title individual grid-container"
  }, [_vm._v("Archive")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation latest layer3"
  }), _vm._v(" "), _c('div', {
    staticClass: "social-latest grid-100 grid-parent layer2"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-100 grid-parent archive-list"
  }, _vm._l((_vm.result), function(item, $index) {
    return ($index < 6) ? _c('div', {
      staticClass: "grid-32 archive-item grid-parent",
      class: {
        'odd': $index % 2 === 0, 'even': $index % 2 !== 0
      }
    }, [_c('div', {
      staticClass: "grid-100 grid-parent archive-content"
    }, [_c('h1', {
      domProps: {
        "innerHTML": _vm._s(item.title.rendered)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "archive-bottom grid-100 grid-parent mobile-grid-100"
    }, [_c('span', {
      staticClass: "archive-date"
    }, [_vm._v(_vm._s(_vm.getDateInFormat(item.date)))]), _vm._v(" "), _c('a', {
      staticClass: "archive-cta",
      on: {
        "click": function($event) {
          return _vm.showArchive(item.id)
        }
      }
    }, [_vm._v("MORE")])])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grid-100 grid-parent"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.olderPostsHidden),
      expression: "olderPostsHidden"
    }],
    staticClass: "see-all-post",
    on: {
      "click": function($event) {
        return _vm.showOlderPosts()
      }
    }
  }, [_c('span', [_vm._v("See older posts")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/arrow-down.svg")
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.olderPostsHidden),
      expression: "!olderPostsHidden"
    }],
    staticClass: "grid-100 grid-parent archive-list"
  }, _vm._l((_vm.result), function(item, $index) {
    return ($index > 6) ? _c('div', {
      staticClass: "grid-32 archive-item grid-parent",
      class: {
        'odd': $index % 2 === 0, 'even': $index % 2 !== 0
      }
    }, [_c('div', {
      staticClass: "grid-100 grid-parent archive-content"
    }, [_c('h1', {
      domProps: {
        "innerHTML": _vm._s(item.title.rendered)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "archive-bottom grid-100 grid-parent mobile-grid-100"
    }, [_c('span', {
      staticClass: "archive-date"
    }, [_vm._v(_vm._s(_vm.getDateInFormat(item.date)))]), _vm._v(" "), _c('a', {
      staticClass: "archive-cta",
      on: {
        "click": function($event) {
          return _vm.showArchive(item.id)
        }
      }
    }, [_vm._v("MORE")])])])]) : _vm._e()
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('h4', [_vm._v("Ross.Noble")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-icon"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/facebook_white.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('h4', [_vm._v("Ross.Noble")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-icon"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/facebook_white.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d4bfc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Latest.vue
// module id = 280
// module chunks = 0